import React from "react";
import { Alert } from "react-bootstrap";

function MessageAlert(props) {
  return (
    <Alert
      className="text-center"
      show={props.showAlert}
      variant={props.variant}
      onClose={props.closeAlert}
      dismissible={props.dismissible}
    >
      {props.alertMessage}
    </Alert>
  );
}

export default MessageAlert;
